module.exports = __webpack_public_path__ + "img/oneDrive.48ff325b.svg";